import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
    return (
        <div className="flex min-h-screen items-center justify-center px-6" data-testid="payment-cancel-page">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                className="max-w-lg text-center"
            >
                <p className="font-cinzel text-xs tracking-[0.4em] text-[#b89860] uppercase">
                    The Gate Remains Open
                </p>
                <h1 className="font-cinzel mt-6 text-4xl text-[#f3e5ab]" data-testid="cancel-heading">
                    Nothing Was Taken
                </h1>
                <p className="font-cormorant mt-6 text-lg italic leading-relaxed text-[#a3b899]">
                    Your pre-order was not completed and you have not been charged.
                    The garden will wait for you.
                </p>
                <Link
                    to="/"
                    data-testid="cancel-return-home-link"
                    className="btn-eden mt-10 inline-block rounded-sm bg-transparent px-8 py-4 text-xs text-[#d4af37]"
                >
                    Return to the Garden
                </Link>
            </motion.div>
        </div>
    );
}
